<template>
  <v-row
    :class="'search-form fixed '+width_class+' top-'+((has_nav_bar)?'with-nav-bar':'no-nav-bar')"
    no-gutters
  >
    <v-col no-gutters>
      <v-row no-gutters>
        <v-col cols="12 pt-4" no-gutters>
          {{business_names}} - {{location_names}}
          <v-row no-gutters>
            <v-col class="ma-0 pl-6 pr-0 pb-0">
              <v-autocomplete
                prepend-inner-icon="mdi-city"
                dense
                filled
                outlined
                clearable
                label="Search for a business ..."
                class="flex-md-grow-1 round-right-0"
                no-filter
                return-object
                v-model="value"
                :disabled="is_loading_auto_complete_items || disabled"
                :items="business_names"
                :search-input.sync="business_name_searching_val"
              ></v-autocomplete>
            </v-col>
            <v-col class="ma-0 pl-0 pr-0 pb-0">
              <v-autocomplete
                prepend-inner-icon="mdi-map-marker"
                dense
                filled
                outlined
                label="Location"
                class="flex-md-grow-1 round-right-0 round-left-0"
                no-filter
                return-object
                v-model="location_value"
                :disabled="is_loading_auto_complete_items || disabled"
                :items="location_names"
              ></v-autocomplete>
            </v-col>
            <v-col class="ma-0 pl-0 pr-6 pb-0" md="auto">
              <v-btn  @click="on_search" class="ma-0 round-right-4 hgt-40" tile filled ripple xoutlined color="primary">
                Search
                <v-icon right>mdi-home-search-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="show_pagination" >
        <v-col cols="12" no-gutters>
          <ResultsPagination></ResultsPagination>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" no-gutters>
          <v-divider></v-divider>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ResultsPagination from "./ResultsPagination";
import Server from "./../lib/ServerClient";
export default {
  name: "CenterSearchForm",
  components: {
    ResultsPagination,
  },
  props: {
    has_nav_bar: {
      type: Boolean,
      default: true,
    },
    width_class: {
      type: String,
      default: "wdth-50p",
    },
    show_pagination: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      business_name_searching_val: null,
      value: "",
      location_value: "",
      business_names: [],
      location_names: [],
      is_loading_auto_complete_items: false
    };
  },
  watch: {
    business_name_searching_val: function(val){
      var value_text = val.trim().toLowerCase();
      var insert_prefix = ""; //"search for: ";
      var text_exists = false;
      for (let index = 0; index < this.business_names.length; index++) {
        var business = this.business_names[index];
        var item_text = business.text.trim().toLowerCase() + insert_prefix;
        if(item_text == value_text){
          //this text is already with us
          text_exists = true;
          break;
        }
      }
      if(text_exists){
        return true;
      }
      
      Server.Search.auto_complete_search_businesses({
        search_term: value_text
      },(res) => {
        //console.log("ser", res);
        var text_totaly_exists = false;
        var new_items = [];
        var server_items = res;
        for (let index = 0; index < server_items.length; index++) {
          var item = server_items[index];
          var item_text = item.name.trim().toLowerCase();
          if(item_text.indexOf(value_text) >= 0){
            //server result contains this item
            text_totaly_exists = true;
          }
          item.kind ="business";
          new_items.push({
            text: item_text,
            value: item
          });
        }
        if(text_totaly_exists == false){
          //push this item as the first item
          new_items.unshift({
            text: value_text + insert_prefix,
            value: {
              id: 0,
              name: value_text,
              kind: "business"
            }
          });
        }
        this.business_names = new_items;
        console.log("businesses names: ", );
      },(errs) => {
        console.log("auto complete searching_val errors value: ", errs);
      });
      
    },
  },
  methods: {
    auto_search_businesses(val) {
      console.log("The value is ", val);
    },
    on_search(){
      this.$emit('on-show-loader')
    }
  },
  mounted(){
    //load the business names for auto complete purposes
    this.is_loading_auto_complete_items = true;
    Server.Search.get_home_search_autocomplete_items({},(res)=>{
      /*
        {
          business_names,
          locations_names
        }
      */
      this.business_names = res.business_names;
      this.location_names = res.locations_names;
      this.is_loading_auto_complete_items = false;
    },(errors) => {
      this.is_loading_auto_complete_items = false;
      console.log("Errors while loading auto completing items: ", errors);
    });
  }
};
</script>

<style scoped>
.search-form {
  /*  #a9a9a905; */
  background-color: white;
  padding-top: 4px;
  z-index: 99;
}
</style>